import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/notifications`,
});

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// 📖 Get All Notifications (paginated + filter)
export async function getAllPostNotifications(payload) {
  try {
    const res = await API.post("/post", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ➕ Send Single Notification
export async function createNotification(payload) {
  try {
    const res = await API.post("/create", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ➕ Send Bulk Notifications
export async function createBulkNotifications(payload) {
  try {
    const res = await API.post("/create-bulk", payload, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✅ Mark Single as Read
export async function markNotificationAsRead(notificationId) {
  try {
    const res = await API.put(`/mark-read/${notificationId}`, {}, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// ✅ Mark All as Read
export async function markAllNotificationsAsRead(recipientId, recipientType) {
  try {
    const res = await API.put("/mark-all-read", { recipientId, recipientType }, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 🗑️ Delete Notification
export async function deleteNotification(id) {
  try {
    const res = await API.delete(`/delete/${id}`, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}

// 🔢 Get Unread Count
export async function getUnreadCount(recipientId, recipientType) {
  try {
    const res = await API.get(`/unread-count/${recipientId}/${recipientType}`, { headers: authHeader() });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.message || err.message };
  }
}